export default __webpack_public_path__ + "static/media/AndarTitle.ca663b4e.svg";